import { Accordion, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaEdit, FaSave } from 'react-icons/fa';

interface BasicConfigurationProps {
    displayName: string;
    setDisplayName: (value: string) => void;
    greeting: string;
    setGreeting: (value: string) => void;
    systemPrompt: string;
    setSystemPrompt: (value: string) => void;
    hidePoweredBy: boolean;
    setHidePoweredBy: (value: boolean) => void;
    permission: boolean;
    subscription: any;
    orgId: string;
    isLoading: boolean;
    onUpdate: () => void;
}

function BasicConfiguration({
    displayName,
    setDisplayName,
    greeting,
    setGreeting,
    systemPrompt,
    setSystemPrompt,
    hidePoweredBy,
    setHidePoweredBy,
    permission,
    subscription,
    orgId,
    isLoading,
    onUpdate
}: BasicConfigurationProps) {
    return (
        <Accordion.Item eventKey="0" style={{ backgroundColor: '#2d2d2d', border: '1px solid #444', marginBottom: '1rem' }}>
            <Accordion.Header style={{ backgroundColor: '#2d2d2d' }}>
                <div className="d-flex align-items-center">
                    <div className="bg-primary rounded p-2 me-3">
                        <FaEdit className="text-white" />
                    </div>
                    <div>
                        <span className="text-light fw-bold">Basic Configuration</span>
                        <br />
                        <small style={{ color: '#999' }}>Configure your agent's core settings</small>
                    </div>
                </div>
            </Accordion.Header>
            <Accordion.Body style={{ backgroundColor: '#2d2d2d' }}>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold text-light">Display Name</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder='e.g. AI Assistant'
                            value={displayName}
                            disabled={permission}
                            onChange={(e) => setDisplayName(e.target.value)}
                            style={{ 
                                backgroundColor: permission ? '#444' : '#1a1a1a', 
                                borderColor: '#555',
                                color: '#fff'
                            }}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold text-light">Greeting Message</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder='e.g. Hello! How can I help you today?'
                            value={greeting}
                            disabled={permission}
                            onChange={(e) => setGreeting(e.target.value)}
                            style={{ 
                                backgroundColor: permission ? '#444' : '#1a1a1a', 
                                borderColor: '#555',
                                color: '#fff'
                            }}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold text-light">System Prompt</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={6}
                            disabled={permission}
                            placeholder='Enter system prompt to define your agent behavior...'
                            value={systemPrompt}
                            onChange={(e) => setSystemPrompt(e.target.value)}
                            style={{ 
                                backgroundColor: permission ? '#444' : '#1a1a1a', 
                                borderColor: '#555',
                                color: '#fff'
                            }}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Check
                            disabled={subscription && subscription.name === "Free"}
                            type="switch"
                            id="custom-switch"
                            label="Hide Powered by QuickyChat.com"
                            checked={hidePoweredBy}
                            onChange={() => setHidePoweredBy(!hidePoweredBy)}
                            style={{ color: '#ccc' }}
                        />
                        {subscription && subscription.name === "Free" && (
                            <Alert 
                                variant="warning" 
                                className="mt-2"
                                style={{ backgroundColor: '#2d2a1a', borderColor: '#ffc107', color: '#fff3cd' }}
                            >
                                <Link to={`/dashboard/orgs/${orgId}/plans`} style={{ color: '#ffc107' }}>
                                    Upgrade to remove branding
                                </Link>
                            </Alert>
                        )}
                    </Form.Group>

                    <div className="d-flex justify-content-end">
                        <Button
                            disabled={permission || isLoading}
                            variant="primary"
                            onClick={onUpdate}
                            className="px-4"
                        >
                            {isLoading ? (
                                <>
                                    <Spinner as="span" animation="border" size="sm" className="me-2" />
                                    Updating...
                                </>
                            ) : (
                                <>
                                    <FaSave className="me-2" />
                                    Update Configuration
                                </>
                            )}
                        </Button>
                    </div>
                </Form>
            </Accordion.Body>
        </Accordion.Item>
    );
}

export default BasicConfiguration;